import React, { useEffect } from "react";
import { string } from "prop-types";

import "./sticky-banner.m.css";

const StickyBanner = ({ publisherName }) => {
  const adUnits = {};

  if (publisherName === "fit") {
    adUnits.id = "div-gpt-ad-1599217381793-0";
    adUnits.slot = "/52868882/FIT20_Sticky_V2";
  } else if (publisherName === "quint") {
    adUnits.id = "div-gpt-ad-1599048664928-0";
    adUnits.slot = "/52868882/TQ20_Sticky_V2";
  } else {
    adUnits.id = "div-gpt-ad-1599217863835-0";
    adUnits.slot = "/52868882/HQ20_Sticky_V2";
  }

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.async = true;
    script1.innerHTML = `window.googletag = window.googletag || {cmd: []};
    googletag.cmd.push(function() {
    googletag.defineSlot("${adUnits.slot}", [320, 50], "${adUnits.id}").addService(googletag.pubads());
    googletag.pubads().enableSingleRequest();
    googletag.pubads().collapseEmptyDivs();
    googletag.enableServices();
    })`;
    document.head.appendChild(script1);
    const script2 = document.createElement("script");
    script2.async = true;
    script2.innerHTML = `googletag.cmd.push(function() { googletag.display("${adUnits.id}"); })`;
    document.body.appendChild(script2);
  }, []);

  return (
    <div styleName="wrapper">
      <div styleName="banner">
        <div id={adUnits.id}></div>
      </div>
    </div>
  );
};

StickyBanner.propTypes = {
  publisherName: string,
};

export default StickyBanner;
